module.exports = __webpack_public_path__ + "static/media/nonord-c-2.ed1ea238.mp3";